import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { SocketProvider } from './hooks/useSocket';
import { IaJobsProvider } from './context/IaJobsProvider';
import { OnboardingPackProvider } from './context/OnboardingPackProvider';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

const RootPage = lazy(() => import('./pages/Root'));
const LoginPage = lazy(() => import('./pages/Login'));
const SignupProfilePage = lazy(() => import('./pages/SignupProfile'));
const SignupAccountPage = lazy(() => import('./pages/SignupAccount'));
const SignupSuccessPage = lazy(() => import('./pages/SignupSuccess'));
const SignupCancelPage = lazy(() => import('./pages/SignupCancel'));
const SignupResumePage = lazy(() => import('./pages/SignupResume'));
const TermsPage = lazy(() => import('./pages/Terms'));
const PrivacyPage = lazy(() => import('./pages/Privacy'));
const WorkoutPage = lazy(() => import('./pages/Workout'));
const HistoryPage = lazy(() => import('./pages/History'));
const StatisticsPage = lazy(() => import('./pages/Statistics'));
const ProfilePage = lazy(() => import('./pages/Profile'));
const AiPlanPage = lazy(() => import('./pages/AiPlan'));
const WorkoutsManagePage = lazy(() => import('./pages/WorkoutsManage'));
const DuoPage = lazy(() => import('./pages/Duo'));

function RouteFallback() {
  return (
    <div className="flex items-center justify-center min-h-[40vh]">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-iron-border border-t-iron-accent" />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <SocketProvider>
          <IaJobsProvider>
          <OnboardingPackProvider>
          <Layout>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/start" element={<SignupProfilePage />} />
                <Route path="/register" element={<SignupAccountPage />} />
                <Route path="/register/success" element={<SignupSuccessPage />} />
                <Route path="/register/cancel" element={<SignupCancelPage />} />
                <Route path="/register/resume" element={<SignupResumePage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />

                <Route path="/" element={<RootPage />} />
                <Route path="/workout" element={<ProtectedRoute><WorkoutPage /></ProtectedRoute>} />
                <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
                <Route path="/statistics" element={<ProtectedRoute><StatisticsPage /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                <Route path="/plan" element={<ProtectedRoute><AiPlanPage /></ProtectedRoute>} />
                <Route path="/workouts-manage" element={<ProtectedRoute><WorkoutsManagePage /></ProtectedRoute>} />
                <Route path="/duo" element={<ProtectedRoute><DuoPage /></ProtectedRoute>} />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </Layout>
          </OnboardingPackProvider>
          </IaJobsProvider>
        </SocketProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
